export class soulHandler {
    constructor() {
        this.soulInventory = {};
        this.elementNames = ["fire", "earth", "light", "wind", "cold", "water", "lightning", "dark"];
        this.tiers = [1, 2, 3, 4, 5, 6];
    }

    checkInventory(element, tier) {
        if (!this.elementNames.includes(element)) {
            console.log("error: soul with element that does not exist")
            return false
        }

        if (!this.tiers.includes(tier)) {
            console.log(tier);
            console.log("error: soul with tier that does not exist")
            return false
        }

        if (this.soulInventory[element] === undefined) {
            this.soulInventory[element] = {}
        }

        if (this.soulInventory[element][tier] === undefined) {
            this.soulInventory[element][tier] = new Decimal(0);
        }

        return true;
    }

    hasEnoughSouls(element, tier, amount) {
        const cost = new Decimal(amount);
        if (this.checkInventory(element, tier)) {
            return this.soulInventory[element][tier].gte(cost);
        } else {
            return false;
        }
    }

    spendSouls(element, tier, amount) {
        const cost = new Decimal(amount);
        if (this.hasEnoughSouls(element, tier, cost)) {
            this.soulInventory[element][tier] = this.soulInventory[element][tier].minus(cost);
            return true;
        } else {
            return false;
        }
    }

    incrementSouls(element, tier, amount = 1) {
        const gain = new Decimal(amount);
        if (this.checkInventory(element, tier)) {
            this.soulInventory[element][tier] = this.soulInventory[element][tier].add(gain);
            return true;
        } else {
            return false
        }
    }

    addMonsterSouls(monster) {
        let monsterDrops = monster.calculateDrops();
        this.incrementSouls(monsterDrops.element, monsterDrops.tier, monsterDrops.amount);
    }

    getSouls(element, tier) {
        if (this.checkInventory(element, tier)) {
            return this.soulInventory[element][tier];
        } else {
            return new Decimal(0);
        }
    }

    saveToData() {
        return this.soulInventory;
    }

    loadFromData(savedData) {
        this.soulInventory = {};

        if (savedData && typeof savedData === 'object') {
            for (const [elementName, tiersObj] of Object.entries(savedData)) {
                this.soulInventory[elementName] = {};
                for (const [tier, amount] of Object.entries(tiersObj)) {
                    this.soulInventory[elementName][Number(tier)] = new Decimal(amount || 0);
                }
            }
        }
    }
}